var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{staticStyle:{"margin":"auto","max-width":"320px"},attrs:{"label":"User Code"},on:{"keyup":_vm.uppercaseUserCode},model:{value:(_vm.userCode),callback:function ($$v) {_vm.userCode=$$v},expression:"userCode"}})}
var staticRenderFns = []

export { render, staticRenderFns }